import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { isValid as isValidCpfFnando } from '@fnando/cpf'
import { isValid as isValidCnpjFnando } from '@fnando/cnpj'

export function formatCurrency(value: number) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

export function formatDate(dateStr: string | null | undefined) {
  if (!dateStr) return '—'
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy', { locale: ptBR })
  } catch {
    return dateStr
  }
}

export function formatDateTime(dateStr: string | null | undefined) {
  if (!dateStr) return '—'
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy HH:mm', { locale: ptBR })
  } catch {
    return dateStr
  }
}

export function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text)
}

export function formatCpf(cpf: string) {
  const digits = cpf.replace(/\D/g, '')
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export function stripCpf(cpf: string) {
  return cpf.replace(/\D/g, '')
}

export function isValidCpf(cpf: string) {
  return isValidCpfFnando(cpf ?? '')
}

export function semAcento(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
}

export function formatCnpj(cnpj: string) {
  const digits = cnpj.replace(/\D/g, '')
  return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
}

export function isValidCnpj(cnpj: string) {
  return isValidCnpjFnando(cnpj ?? '')
}

export function formatTelefone(telefone: string) {
  const digits = telefone.replace(/\D/g, '')
  if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
  return telefone
}
